import { backendApi } from "@/services/backend/api";
import { ActiveCatalogRelease } from "@/services/backend/qpm/catalog/types/catalog";

const qpmBootstrapServiceApi = backendApi
  .enhanceEndpoints({
    addTagTypes: [
      "QpmCatalog",
      "QpmActiveCatalog",
      "QpmActiveCatalogRelease",
      "QpmOfferConfigSettings",
    ],
  })
  .injectEndpoints({
    endpoints: (build) => ({
      qpmBootstrapUpdateBaseData: build.mutation<
        ActiveCatalogRelease,
        Record<string, string>
      >({
        query: (request) => ({
          url: `/qpm/bootstrap/update/base-data`,
          method: "POST",
          body: request,
        }),
        invalidatesTags: [
          "QpmCatalog",
          "QpmActiveCatalog",
          "QpmActiveCatalogRelease",
        ],
      }),
      qpmBootstrapUpdateMonitors: build.mutation<
        ActiveCatalogRelease,
        Record<string, string>
      >({
        query: (request) => ({
          url: `/qpm/bootstrap/update/monitors`,
          method: "POST",
          body: request,
        }),
        invalidatesTags: [
          "QpmCatalog",
          "QpmActiveCatalog",
          "QpmActiveCatalogRelease",
        ],
      }),
      qpmBootstrapSeed: build.mutation<
        ActiveCatalogRelease,
        Record<string, string>
      >({
        query: (request) => ({
          url: `/qpm/bootstrap/seed`,
          method: "POST",
          body: request,
        }),
        invalidatesTags: [
          "QpmCatalog",
          "QpmActiveCatalog",
          "QpmActiveCatalogRelease",
        ],
      }),
      qpmBootstrapUpdateServiceProgram: build.mutation<
        Record<string, never>,
        Record<string, never>
      >({
        query: (request) => ({
          url: `/qpm/bootstrap/update/service-program`,
          method: "POST",
          body: request,
        }),
        invalidatesTags: [{ type: "QpmOfferConfigSettings", id: "SINGLE" }],
      }),
    }),
  });

export const {
  useQpmBootstrapUpdateBaseDataMutation,
  useQpmBootstrapUpdateMonitorsMutation,
  useQpmBootstrapSeedMutation,
  useQpmBootstrapUpdateServiceProgramMutation,
} = qpmBootstrapServiceApi;
